// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-large);
  min-width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
}

form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-medium);
  width: 100%;
  max-width: 500px;
}

h1.mat-headline-3 {
  margin-bottom: var(--spacing-large);
}

.line {
  display: block;
}

label,
button {
  display: block;
  margin-top: var(--spacing-smaller);
}

mat-form-field {
  width: 100%;
}

.error {
  margin-top: var(--spacing-medium);
  color: var(--color-red);
  text-align: center;
}

mat-form-field {
  margin-bottom: var(--spacing-medium);
}

.links-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.buttons-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-medium);
  width: 67%;
}

.mdc-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authentication/authentication.common.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,mCAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;;EAEE,cAAA;EACA,kCAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,iCAAA;EACA,uBAAA;EACA,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;AADF;;AAIA;EACE,WAAA;AADF","sourcesContent":["@use \"../../shared/components/media-queries\" as mq;\n\n:host {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-large);\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-medium);\n  width: 100%;\n  max-width: 500px;\n}\n\nh1.mat-headline-3 {\n  margin-bottom: var(--spacing-large);\n}\n\n.line {\n  display: block;\n}\n\nlabel,\nbutton {\n  display: block;\n  margin-top: var(--spacing-smaller);\n}\n\nmat-form-field {\n  width: 100%;\n}\n\n.error {\n  margin-top: var(--spacing-medium);\n  color: var(--color-red);\n  text-align: center;\n}\n\nmat-form-field {\n  margin-bottom: var(--spacing-medium);\n}\n\n.links-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n\n.buttons-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-medium);\n  width: 67%;\n}\n\n.mdc-button {\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
